import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RouteHistoryService } from "./route-history.service";
import { RouteHistoryItem } from "./route-history-item";
import { PortalService } from '../../portal/portal.service';
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

@Component({
  selector: 'brd-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements OnInit {
  @Input()
  title: string = '';
  isPortal: boolean = false; 

  @Input()
  backOnSelf: boolean = false;
  @Output()
  onBack: EventEmitter<any> = new EventEmitter();

  opened: boolean = false;

  constructor(public historyService: RouteHistoryService,
    private route: ActivatedRoute,) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(qp => {
      var isPortalValue = qp['isPortal'];
      if (isPortalValue) {
        this.isPortal = isPortalValue;
      }
    });
  }

  onHistoryOpened() {
    this.opened = true;
  }

  onHistoryClosed() {
    setTimeout(() => {
      this.opened = false;
    }, 150);
  }

  back() {
    if (this.backOnSelf) {
      this.onBack.emit();
    }
    else {
      this.historyService.goBack();
    }
  }

  goBackTo(item: RouteHistoryItem) {
    this.historyService.goBack(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/layout/layout.component.ts